/** Supabase city_master fallback — primary source is DB via cityApi */

export const POPULAR_CITIES_BY_COUNTRY = {
  VN: ['da_nang', 'hcmc', 'hanoi', 'hoi_an', 'nha_trang', 'phu_quoc'],
  TH: ['bangkok', 'phuket', 'chiang_mai', 'pattaya'],
  KR: ['seoul', 'busan', 'jeju'],
  JP: ['tokyo', 'osaka', 'fukuoka'],
  PH: ['manila', 'cebu', 'boracay'],
  ID: ['bali', 'jakarta'],
};

export const DEFAULT_CURRENCY_BY_COUNTRY = {
  VN: 'VND',
  TH: 'THB',
  KR: 'KRW',
  JP: 'JPY',
  DE: 'EUR',
  FR: 'EUR',
  PH: 'PHP',
  ID: 'IDR',
  US: 'USD',
  DEFAULT: 'USD',
};

export const CURRENCIES = ['USD', 'VND', 'KRW', 'THB', 'JPY', 'EUR', 'PHP', 'IDR'];

/** 통화별 가장 흔히 쓰이는 단독 기호 — 코드(USD 등) 대신 한 줄로 짧게 표시할 때 사용 */
export const CURRENCY_SYMBOLS = {
  KRW: '₩',
  USD: '$',
  JPY: '¥',
  CNY: '¥',
  EUR: '€',
  GBP: '£',
  RUB: '₽',
  TRY: '₺',
  INR: '₹',
  THB: '฿',
  VND: '₫',
  PHP: '₱',
  ILS: '₪',
  IDR: 'Rp',
};

/** @param {string} code @returns {string} 기호가 없으면 코드 그대로 */
export function getCurrencySymbol(code) {
  const c = String(code || '').toUpperCase();
  return CURRENCY_SYMBOLS[c] || c;
}

/** 기호가 숫자 뒤에 붙는 통화 (베트남 동 등 현지 표기 관행) — 그 외는 전부 앞에 붙임 */
const SUFFIX_SYMBOL_CURRENCIES = new Set(['VND']);

/**
 * 통화 기호 위치까지 반영한 금액 표시 (예: USD → $130,000 / VND → 130,000₫)
 * @param {number|string} amount
 * @param {string} [currencyCode]
 * @returns {string}
 */
export function formatCurrencyAmount(amount, currencyCode) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '';
  const symbol = getCurrencySymbol(currencyCode);
  const formatted = n.toLocaleString('en-US');
  const cc = String(currencyCode || '').toUpperCase();
  return SUFFIX_SYMBOL_CURRENCIES.has(cc) ? `${formatted}${symbol}` : `${symbol}${formatted}`;
}

export const LANGUAGE_ORDER_BY_COUNTRY = {
  VN: ['ko', 'vi', 'en', 'ja', 'zh', 'ru'],
  TH: ['ko', 'th', 'en', 'ja', 'zh'],
  KR: ['ko', 'en', 'ja', 'zh', 'vi'],
  DEFAULT: ['ko', 'en', 'vi', 'ja', 'zh', 'ru', 'th', 'de'],
};

export function getLanguageOrder(countryCode) {
  const cc = String(countryCode || '').toUpperCase();
  return LANGUAGE_ORDER_BY_COUNTRY[cc] || LANGUAGE_ORDER_BY_COUNTRY.DEFAULT;
}

export function getDefaultCurrency(countryCode) {
  const cc = String(countryCode || '').toUpperCase();
  return DEFAULT_CURRENCY_BY_COUNTRY[cc] || DEFAULT_CURRENCY_BY_COUNTRY.DEFAULT;
}

/** UI 표시용 국가명 (뉴스 섹션 제목 등) */
export const COUNTRY_NAME_BY_CODE = {
  VN: { ko: '베트남', en: 'Vietnam', vi: 'Việt Nam', ru: 'Вьетнам' },
  TH: { ko: '태국', en: 'Thailand', vi: 'Thái Lan', ru: 'Таиланд' },
  KR: { ko: '한국', en: 'Korea', vi: 'Hàn Quốc', ru: 'Корея' },
  JP: { ko: '일본', en: 'Japan', vi: 'Nhật Bản', ru: 'Япония' },
  PH: { ko: '필리핀', en: 'Philippines', vi: 'Philippines', ru: 'Филиппины' },
  ID: { ko: '인도네시아', en: 'Indonesia', vi: 'Indonesia', ru: 'Индонезия' },
};

export function getCountryDisplayName(countryCode, language) {
  const cc = String(countryCode || 'VN').toUpperCase();
  const entry = COUNTRY_NAME_BY_CODE[cc];
  if (!entry) return cc;
  const lang = String(language || 'en').split('-')[0].toLowerCase();
  return entry[lang] || entry.en || cc;
}
